// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.engagementFilterBlock__ZIuO8 {
  width: 100%;
  position: relative;
  z-index: 9;
}

.engagementFilterBlockContainer__dE9OU {
  height: 100%;
  background: var(--tables-primary-row-surface-default);
  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
}

.filterFieldContainer__iNn_d {
  width: 100%;
  max-width: 200px;
  min-width: 200px;
}
@media (max-width: 1024px) {
  .filterFieldContainer__iNn_d {
    max-width: 100%;
    min-width: unset;
  }
}

.filterFields__jrotr {
  display: flex;
  padding: 15px 25px;
  justify-content: space-between;
  border-bottom: 1px solid var(--header-stroke);
}

.leftFilterFields__vuj0r {
  display: flex;
  gap: 10px;
}

.rightFilterFields__A5c8a {
  margin-top: 19px;
  display: flex;
  align-items: center;
}
.rightFilterFields__A5c8a .iconContainer__P6N2v:first-child {
  margin-right: 1px;
}
@media (max-width: 900px) {
  .rightFilterFields__A5c8a {
    margin-top: 12px;
  }
}

.additionalFiltersContainer__RnZQQ {
  margin-top: 19px;
  display: flex;
  align-items: center;
  gap: 10px;
}
@media (max-width: 900px) {
  .additionalFiltersContainer__RnZQQ {
    margin-top: 12px;
  }
}

.iconContainer__P6N2v {
  width: 35px;
  height: 35px;
  border-radius: 2px;
  background: var(--segments-chips-toggle-surface-default);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.iconContainer__P6N2v .searchIcon__f4R1f path {
  stroke: var(--segments-chips-toggle-text-default);
}
.iconContainer__P6N2v .statisticIcon__VfCuE path {
  fill: var(--segments-chips-toggle-text-default);
}
.iconContainer__P6N2v .threeDotsIcon__ukA31 circle {
  fill: var(--segments-chips-toggle-text-default);
}

.active__GIej7 {
  background: var(--segments-chips-toggle-surface-active);
}
.active__GIej7 .searchIcon__f4R1f path {
  stroke: var(--buttons-surface);
}
.active__GIej7 .statisticIcon__VfCuE path {
  fill: var(--buttons-surface);
}
.active__GIej7 .threeDotsIcon__ukA31 circle {
  fill: var(--buttons-surface);
}

.searchPanel__KnSPZ {
  width: 100%;
  display: flex;
  padding: 0px 25px;
  height: 45px;
  box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
}

.additionalMenuPopover__PLgDg {
  padding: 25px;
  position: absolute;
  right: 30px;
  top: 0;
  background: white;
}

.statusesControl__nnz0g {
  padding-top: 25px;
}

.statusesControlItems__b8xf_ {
  display: flex;
  gap: 7px;
}

.statusesControlItem__wnNXG {
  padding: 5px 12px;
  border-radius: 15px;
  border: 1px solid var(--segments-chips-toggle-stroke-default);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--segments-chips-toggle-text-default);
  cursor: pointer;
}

.activeStatusesControlItem__gkVaQ {
  border: 1px solid var(--buttons-surface);
  background: var(--segments-chips-toggle-surface-active);
}

.filterIcon__YNKkB {
  position: relative;
}

.activeExtraFiltersIconDot__qaPKH {
  display: block;
}
.activeExtraFiltersIconDot__qaPKH:after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--buttons-surface);
}

@media (max-width: 1550px) {
  .activeSmallWidthExtraFiltersIconDot__foKdj {
    display: block;
  }
  .activeSmallWidthExtraFiltersIconDot__foKdj:after {
    content: "";
    position: absolute;
    top: -2px;
    right: -2px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--buttons-surface);
  }
}

@media (max-width: 1550px) {
  .smallWidthHide__C1NDh {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/SiteEngagement/components/FilterPanel/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,qDAAA;EACA,iDAAA;EACA,mDAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AAzEF;AA0EE;EAJF;IAKI,eAAA;IACA,gBAAA;EAvEF;AACF;;AA0EA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,6CAAA;AAvEF;;AA0EA;EACE,aAAA;EACA,SAAA;AAvEF;;AA0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAvEF;AAyEE;EACE,iBAAA;AAvEJ;AA0EE;EATF;IAUI,gBAAA;EAvEF;AACF;;AA0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAvEF;AAyEE;EANF;IAOI,gBAAA;EAtEF;AACF;;AAyEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAtEF;AAyEI;EACE,iDAAA;AAvEN;AA2EI;EACE,+CAAA;AAzEN;AA6EI;EACE,+CAAA;AA3EN;;AAgFA;EACE,uDAAA;AA7EF;AAgFI;EACE,8BAAA;AA9EN;AAkFI;EACE,4BAAA;AAhFN;AAoFI;EACE,4BAAA;AAlFN;;AAuFA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,2FACE;AArFJ;;AAyFA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,iBAAA;AAtFF;;AAyFA;EACE,iBAAA;AAtFF;;AAyFA;EACE,aAAA;EACA,QAAA;AAtFF;;AAyFA;EACE,iBAAA;EACA,mBAAA;EACA,6DAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;EACA,eAAA;AAtFF;;AAyFA;EACE,wCAAA;EACA,uDAAA;AAtFF;;AAyFA;EACE,kBAAA;AAtFF;;AAwGA;EAdE,cAAA;AAtFF;AAwFE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;AAtFJ;;AA+FE;EADF;IAlBE,cAAA;EAvEA;EAyEA;IACE,WAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;IACA,WAAA;IACA,kBAAA;IACA,kCAAA;EAvEF;AACF;;AAqFE;EADF;IAEI,aAAA;EAjFF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.engagementFilterBlock {\n  width: 100%;\n  position: relative;\n  z-index: 9;\n}\n\n.engagementFilterBlockContainer {\n  height: 100%;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n}\n\n.filterFieldContainer {\n  width: 100%;\n  max-width: 200px;\n  min-width: 200px;\n  @media (max-width: 1024px) {\n    max-width: 100%;\n    min-width: unset;\n  }\n}\n\n.filterFields {\n  display: flex;\n  padding: 15px 25px;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--header-stroke);\n}\n\n.leftFilterFields {\n  display: flex;\n  gap: 10px;\n}\n\n.rightFilterFields {\n  margin-top: 19px;\n  display: flex;\n  align-items: center;\n\n  .iconContainer:first-child {\n    margin-right: 1px;\n  }\n\n  @media (max-width: 900px) {\n    margin-top: 12px;\n  }\n}\n\n.additionalFiltersContainer {\n  margin-top: 19px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  @media (max-width: 900px) {\n    margin-top: 12px;\n  }\n}\n\n.iconContainer {\n  width: 35px;\n  height: 35px;\n  border-radius: 2px;\n  background: var(--segments-chips-toggle-surface-default);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  .searchIcon {\n    path {\n      stroke: var(--segments-chips-toggle-text-default);\n    }\n  }\n  .statisticIcon {\n    path {\n      fill: var(--segments-chips-toggle-text-default);\n    }\n  }\n  .threeDotsIcon {\n    circle {\n      fill: var(--segments-chips-toggle-text-default);\n    }\n  }\n}\n\n.active {\n  background: var(--segments-chips-toggle-surface-active);\n\n  .searchIcon {\n    path {\n      stroke: var(--buttons-surface);\n    }\n  }\n  .statisticIcon {\n    path {\n      fill: var(--buttons-surface);\n    }\n  }\n  .threeDotsIcon {\n    circle {\n      fill: var(--buttons-surface);\n    }\n  }\n}\n\n.searchPanel {\n  width: 100%;\n  display: flex;\n  padding: 0px 25px;\n  height: 45px;\n  box-shadow:\n    0px 0px 1px 0px rgba(12, 26, 75, 0.24),\n    0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n}\n\n.additionalMenuPopover {\n  padding: 25px;\n  position: absolute;\n  right: 30px;\n  top: 0;\n  background: white;\n}\n\n.statusesControl {\n  padding-top: 25px;\n}\n\n.statusesControlItems {\n  display: flex;\n  gap: 7px;\n}\n\n.statusesControlItem {\n  padding: 5px 12px;\n  border-radius: 15px;\n  border: 1px solid var(--segments-chips-toggle-stroke-default);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--segments-chips-toggle-text-default);\n  cursor: pointer;\n}\n\n.activeStatusesControlItem {\n  border: 1px solid var(--buttons-surface);\n  background: var(--segments-chips-toggle-surface-active);\n}\n\n.filterIcon {\n  position: relative;\n}\n\n@mixin extraFiltersIconDot {\n  display: block;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: var(--buttons-surface);\n  }\n}\n\n.activeExtraFiltersIconDot {\n  @include extraFiltersIconDot;\n}\n\n.activeSmallWidthExtraFiltersIconDot {\n  @media (max-width: 1550px) {\n    @include extraFiltersIconDot;\n  }\n}\n\n.smallWidthHide {\n  @media (max-width: 1550px) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"engagementFilterBlock": `engagementFilterBlock__ZIuO8`,
	"engagementFilterBlockContainer": `engagementFilterBlockContainer__dE9OU`,
	"filterFieldContainer": `filterFieldContainer__iNn_d`,
	"filterFields": `filterFields__jrotr`,
	"leftFilterFields": `leftFilterFields__vuj0r`,
	"rightFilterFields": `rightFilterFields__A5c8a`,
	"iconContainer": `iconContainer__P6N2v`,
	"additionalFiltersContainer": `additionalFiltersContainer__RnZQQ`,
	"searchIcon": `searchIcon__f4R1f`,
	"statisticIcon": `statisticIcon__VfCuE`,
	"threeDotsIcon": `threeDotsIcon__ukA31`,
	"active": `active__GIej7`,
	"searchPanel": `searchPanel__KnSPZ`,
	"additionalMenuPopover": `additionalMenuPopover__PLgDg`,
	"statusesControl": `statusesControl__nnz0g`,
	"statusesControlItems": `statusesControlItems__b8xf_`,
	"statusesControlItem": `statusesControlItem__wnNXG`,
	"activeStatusesControlItem": `activeStatusesControlItem__gkVaQ`,
	"filterIcon": `filterIcon__YNKkB`,
	"activeExtraFiltersIconDot": `activeExtraFiltersIconDot__qaPKH`,
	"activeSmallWidthExtraFiltersIconDot": `activeSmallWidthExtraFiltersIconDot__foKdj`,
	"smallWidthHide": `smallWidthHide__C1NDh`
};
module.exports = ___CSS_LOADER_EXPORT___;
